import { Icon } from 'common/icon';
import { Routes } from 'constants/routes';
import { IBlogPost } from 'constants/types';
import Image from 'next/image';
import Link from 'next/link';
import styles from './styles.module.css';

interface NewsCardProps {
  data: IBlogPost;
  type?: 'blog-and-news' | 'guide';
}

export const NewsCard = ({ data }: NewsCardProps) => {
  return (
    <Link
      prefetch={false}
      className={styles.card}
      href={Routes.dynamicBlogPage(data)}
    >
      <div className={styles.wrapper}>
        <Image
          width={217}
          height={192}
          src={data.imageUrl}
          alt=""
          className={styles.image}
        />
        <div className={styles.count}>
          <Icon.Message />
          <span>{data?.commentsCount}</span>
        </div>
        <div className={styles.title}>
          <div className={styles.title_wrapper}>
            <h3 className={styles.news_title}>{data.title}</h3>
          </div>
        </div>
      </div>
    </Link>
  );
};
